/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, List, ListItemButton, ListSubheader } from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ReviewStudent from 'screen/counselor/ReviewStudent';
import { checkEnableParseJSON, pickPreferredCounselorYear, parseGraduationYear, removeDuplicate } from 'components/helper/helper';
import { counselorMenuGroups } from 'router/router';
import { useAppDispatch, useAppSelector } from 'app/hooks';
// import { authenticateSettings } from 'components/helper/appConfig';
import { logout, setCurrentStudentId } from 'app/basicInformationSlice/basicInformationSlice';
import { routers } from 'router/router';
import testingServices from 'services/testingServices';
import familyServices from 'services/familyServices';
// import counselorServices from 'services/counselorServices';
import websocketService from 'services/websocketService';
import { getAccessToken, removeUserId, removeAccessToken, getUserRole } from 'utils/sessionStorage';
import { usePageStatus } from 'hooks/usePageStatus';
import { PAGE_NAME } from 'constants/common';
import { isLegalGuardianHome } from 'screen/family/household/permanentHome';

type Props = {
  sidebarCollapsed?: boolean;
};

const CounselorListMenu = (props: Props) => {
  const [open, setOpen] = useState<string | number | null>(null);
  let history = useHistory();
  let location = useLocation();
  const dispatch:any = useAppDispatch();
  const menu = useAppSelector((store) => store.counselor.studentList);
  const parentLists = useAppSelector((store) => store.basicInformation.partners);
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const [menuGroups, setMenuGroups] = useState(counselorMenuGroups);
  const[studentId, setStudentId] = useState<Number|undefined>(undefined);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const lastJoinedStudentIdRef = useRef<number | null>(null);

  const isCounselorOrParent =
    personalStore?.user_role === 'counselor' || personalStore?.user_role === 'parent';
  const isListLoading =
    isCounselorOrParent && (parentLists === null || parentLists === undefined);
  //const [completedPages, setCompletedPages] = useState<Set<string>>(new Set());

  const handleClick = (route: any) => {
    if (open === route.name) return setOpen(null);
    setOpen(route.name);
    if (route.isGroup === false) {
      history.push(route.route.path);
    }
  };  

  
  useEffect(() => {
    if (menu?.length) {
      let menuRebuild = menu
        .filter((i) => i.student_info)
        .map((item) => ({
          name: [item.student_info?.first_name, item.student_info?.last_name].join(' '),
          id: item.student_id,
          groupYear: item?.student_info?.year_finish_high_school,
          component: ReviewStudent,
          path: `/application/counselor/${item.student_id}`,
        }))
        .sort((a: any, b: any) => {
          const aLower: string = a.name.toLowerCase();
          const bLower: string = b.name.toLowerCase();
          if (aLower < bLower) return -1;
          if (aLower > bLower) return 1;
          return 0;
        })
        .sort((a: any, b: any) => b.groupYear - (a.groupYear ?? 0));

      let menuGroup = removeDuplicate(menuRebuild.map((e: any) => e.groupYear)).map((menuItem) => ({
        name: menuItem,
        isGroup: true,
        children: menuRebuild.filter((e: any) => e.groupYear === menuItem),
      }));
      setMenuGroups(menuGroup);

      const preferredYear = pickPreferredCounselorYear(menuGroup.map((group: any) => group.name));
      const preferredGroup = menuGroup.find(
        (group: any) => parseGraduationYear(group.name) === preferredYear
      );
      const fallbackGroupName = preferredGroup?.name ?? menuGroup[0]?.name;
      
      // Open the current senior class on first load (Class of 2027 in 2026–27).
      if (isInitialLoad && fallbackGroupName != null) {
        setOpen(fallbackGroupName);
        setIsInitialLoad(false);
      } else if (!isInitialLoad && open && !menuGroup.find((group: any) => group.name === open)) {
        if (fallbackGroupName != null) {
          setOpen(fallbackGroupName);
        }
      }
    }
  }, [menu, isInitialLoad]);
 
  // Sync with URL: expand group and highlight student when navigating to /application/counselor/:id
  useEffect(() => {
    const match = location.pathname.match(/\/application\/counselor\/(\d+)/);
    const urlStudentId = match ? Number(match[1]) : undefined;
    if (urlStudentId !== undefined && menuGroups?.length) {
      const groupContainingStudent = menuGroups.find((g: any) =>
        g.children?.some((c: any) => Number(c.id) === urlStudentId)
      );
      if (groupContainingStudent) {
        setOpen(groupContainingStudent.name);
        setStudentId(urlStudentId);
        dispatch(setCurrentStudentId(urlStudentId));
      }
    }
  }, [location.pathname, menuGroups, dispatch]);

  useEffect(() => {
    const genMenuInfo = async () => {
      try {
        if (menuGroups && parentLists) {
          let menuArr =  menuGroups;
          for(let i=0;i< menuArr.length; i++) {
            let item = menuArr[i];
            if (item.children) {
              for(let j=0; j< item.children.length; j++) {
                let child = item.children[j];
                for (let k=0; k< parentLists.length; k++) {
                  let obj = parentLists[k];
                  if (child.id === obj.student_id) {
                    child.info = obj;
                  }
                }
              }
            }
          }
  
          setMenuGroups(menuArr);
        }
      }
      catch(ex){
        console.log('Error: ', ex);
      }      
    }
    genMenuInfo();
  }, [parentLists]);

  // Auto-join session when component mounts or URL changes with student_id
  useEffect(() => {
    const autoJoinSession = async () => {
      try {
        // Extract student_id from URL path (pattern: /application/counselor/:id)
        const match = location.pathname.match(/\/application\/counselor\/(\d+)/);
        const urlStudentId = match ? Number(match[1]) : null;
        
        if (!urlStudentId) {
          return;
        }

        const userRole = getUserRole();
        if (userRole !== 'counselor' && userRole !== 'parent') {
          return;
        }

        const currentSession = websocketService.getCurrentSessionData();
        if (currentSession?.student_id === urlStudentId) {
          console.log('Already in session with this student, skipping auto-join...');
          lastJoinedStudentIdRef.current = urlStudentId;
          return;
        }

        if (!websocketService.isSocketConnected()) {
          await websocketService.connect();
        }

        if (websocketService.hasJoinedSessionRoom() && currentSession?.student_id !== urlStudentId) {
          await websocketService.leaveSession();
        }

        console.log('Auto-joining session with student from URL:', urlStudentId);
        await websocketService.joinSession(urlStudentId);
        lastJoinedStudentIdRef.current = urlStudentId;
        console.log('Successfully auto-joined session with student');
      } catch (error) {
        console.error('Error auto-joining session:', error);
        // Don't prevent app from working on error
      }
    };

    // Only auto-join if menu is loaded (has students)
    if (menu?.length && menuGroups?.length) {
      autoJoinSession();
    }
  }, [location.pathname, menu, menuGroups, personalStore]);

  const onClickItem = async (child:any) => {
    setStudentId(child?.id);
  
    // Set Selected/current Student Id
    await dispatch(setCurrentStudentId(child?.id));
    
    // Navigate immediately - don't wait for websocket operations
    history.push(child?.path);
    
    // Handle session switching (counselor/parent join student's session = session_studentId)
    const selectedStudentId = child?.id;

    if (selectedStudentId) {
      try {
        const currentSession = websocketService.getCurrentSessionData();
        if (currentSession?.student_id === selectedStudentId) {
          console.log('Already in session with this student, skipping...');
          return;
        }

        if (websocketService.hasJoinedSessionRoom()) {
          await websocketService.leaveSession();
        }

        console.log('Joining session with student:', selectedStudentId);
        await websocketService.joinSession(selectedStudentId);
        lastJoinedStudentIdRef.current = selectedStudentId;
        console.log('Successfully joined session with student');
      } catch (error) {
        console.error('Error handling session:', error);
      }
    }
  }

  if (isListLoading) {
    return (
      <div style={{ height: '100%', overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 120, padding: 16 }}>
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: 36, height: 36 }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <span className="text-field-light mt-2" style={{ fontSize: 14 }}>Loading students...</span>
      </div>
    );
  }

  return (
    <div style={{ height: '100%', overflowY: 'auto' }}>
      <List
        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
        component="nav"
        subheader={
          <ListSubheader component="div" className="fw-bold text-dark fs-5">
            <PeopleAltOutlinedIcon className="mx-1 pb-1" />
            Students
          </ListSubheader>
        }
      >
        {menuGroups.map((route: any, index: any) => {
          return (
            <div key={index}>
              <ListItemButton
                onClick={() => handleClick(route)}
                className={`px-1 my-1 ${open === route.name && 'bg-light'}`}
                sx={{
                  borderRadius: '8px',
                  margin: '4px 0',
                  backgroundColor: open === route.name ? 'rgba(77, 136, 240, 0.12)' : 'transparent',
                }}
              >
                <span className="text-dark fw-5 mx-2 fw-bold">{route.name}</span>
                {route.isGroup && !props.sidebarCollapsed &&
                  (open === route.name ? (
                    <ExpandLess fontSize="small" className="text-field-light" />
                  ) : (
                    <ExpandMore fontSize="small" className="text-field-light" />
                  ))}
              </ListItemButton>
              {route.isGroup && (
                <Collapse in={open === route.name} timeout="auto" unmountOnExit>
                  <div style={{ height: '100%', overflowY: 'auto' }}>
                    <List component="div" disablePadding>
                      {route.children.map((child: any, i: number) => {
                        return (
                        <CounselorSubMenu child={child} index={i} 
                        //parentLists={parentLists} 
                        studentId={studentId} onClickItem={onClickItem}/>
                        );
                      })}
                    </List>
                  </div>
                </Collapse>
              )}
            </div>
          );
        })}
      </List>
    </div>
  );
};

type CounselorSubMenuProps = {
  studentId : any;
  child: any;
  index: number;
  //parentLists: any;
  onClickItem?: (child: any) => void;
};
const CounselorSubMenu = (props: CounselorSubMenuProps) => {
  const dispatch = useAppDispatch();
  let history = useHistory();
  let location = useLocation();  
  const[roleFamily, setRoleFamily] = useState<any>({});
  const[roleTest, setRoleTest] = useState<any>({});
  //const myHousehold = useAppSelector((store) => store.family.myHousehold);
  //const myGeneral = useAppSelector((store) => store.testing.myGeneral);
  const partnerLists = useAppSelector((store) => store.basicInformation.partners);
  // const token = getAccessToken();
  
  const obj = partnerLists && partnerLists.find && partnerLists.find((item: any) => Number(item.student_id) === Number(props.child.id));
  if (obj) {
    props.child.info = obj; // update info
  }

  // Use pageStatus hook for this student
  const { pageStatus } = usePageStatus({ studentId: props.child.id || '' });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  useEffect(() => {
    const syncRoleFamily = async () => {
      if (obj?.student_id) {
        const role = await getRoleFamily(obj?.student_id)
        setRoleFamily(role);
      }
    }
    syncRoleFamily();

  }, [obj]);

  useEffect(() => {
    const syncRoleTest= async () => {
      if (obj?.student_id) {
        const role = await getRoleTest(obj?.student_id);
        setRoleTest(role);
      }
    }
    syncRoleTest();

  }, [obj]);


  const buildRoleTest = (general:any) => {
    const all_tests_wish_report_array:any = checkEnableParseJSON(
      general?.all_tests_wish_report_array ?? {}
    );
    return {
      satTest: all_tests_wish_report_array?.is_SAT,
      actTest: all_tests_wish_report_array?.is_ACT,
      actSubjectTest: all_tests_wish_report_array?.is_AP_Subject,
      ibSubjectTest: all_tests_wish_report_array?.is_IB_Subject,
      ieltsAndPte: all_tests_wish_report_array?.is_PTE || all_tests_wish_report_array?.is_IELTS,
      toeflTest: all_tests_wish_report_array?.is_TOEFL_Paper || all_tests_wish_report_array?.is_TOEFL,
      douLingoTest: all_tests_wish_report_array?.is_DuoLingo,
      clepTest: all_tests_wish_report_array?.is_CLEP,
    };
  }

  async function getRoleTest(studentId:any) {
    let role:any = {
      satTest: false,
      actTest: false,
      actSubjectTest: false,
      ibSubjectTest: false,
      ieltsAndPte: false,
      toeflTest: false,
      douLingoTest: false,
      clepTest: false,
    };
    try {
      const token = getAccessToken();
      if (token) {
        const general:any = await testingServices.getGeneral(studentId);
        //const general:any = await dispatch(getGeneral(studentId)).unwrap();
        role = buildRoleTest(general);        
      }
      else {
        handleLogout();
      }

    }
    catch(ex){
      console.log('Error: ', ex);
    }   
    return role;
  }
   
  const buildRoleFamily = (myHousehold: any) => {
    const who_in_household_array = checkEnableParseJSON(myHousehold?.who_in_household_array, {});
    let role = {
      parentNo1: false,
      parentNo2: false,
      legalGuardian: false,
      stepParent1: false,
      stepParent2: false,
      siblings: false,
    };
    if (who_in_household_array?.is_parent_guardian) {
      role.parentNo1 = true;
      role.parentNo2 = true;
    }
    if (who_in_household_array?.is_sibbling) {
      role.siblings = true;
    }
  
    if (
      myHousehold?.is_listing_step_parents === 'true' &&
      myHousehold?.how_many_step_parents === '1'
    ) {
      role.stepParent1 = true;
    } else if (myHousehold?.is_listing_step_parents === 'true') {
      role.stepParent1 = true;
      role.stepParent2 = true;
    }
    if (isLegalGuardianHome(myHousehold?.whom_live_permanently)) {
      role.legalGuardian = true;
    }
  
    return role;
  };    
  
  async function getRoleFamily(studentId:any) {
    let role:any = {
      parentNo1: false,
      parentNo2: false,
      legalGuardian: false,
      stepParent1: false,
      stepParent2: false,
      siblings: false,
    };
    try {
      const token = getAccessToken();
      if (token) {
        const myHousehold:any = await familyServices.getHousehold(studentId);
        role = buildRoleFamily(myHousehold);
      }
      else {
        handleLogout();
      }
    }
    catch(ex){
      console.log('Error:', ex);
    }
    return role;
  }  

  // Check if all required pages for a group are completed
  const checkGroupCompleted = (groupId: number, checkCounselorVerified: boolean = false) => {
    console.log("🚀 ~ checkGroupCompleted ~ pageStatus:", pageStatus)
    if (!pageStatus || pageStatus.length === 0) {
      return false;
    }

    let requiredPages: string[] = [];
    switch (groupId) {
      case 1:
        requiredPages = [
          PAGE_NAME.BASIC_INFORMATION,
          PAGE_NAME.CONTACT_DETAILS,
          PAGE_NAME.DEMOGRAPHICS,
          PAGE_NAME.CITIZENSHIP,
          PAGE_NAME.CBO,
          PAGE_NAME.OTHER,
        ];
        break;
      case 2:
        requiredPages = [
          PAGE_NAME.HOUSEHOLD,
          PAGE_NAME.PARENT_1,
          PAGE_NAME.PARENT_2,
          PAGE_NAME.SIBLINGS,
        ];
        if (roleFamily?.stepParent1) {
          requiredPages.push(PAGE_NAME.STEP_PARENT_1);
        }
        if (roleFamily?.stepParent2) {
          requiredPages.push(PAGE_NAME.STEP_PARENT_2);
        }
        break;
      case 3:
        requiredPages = [
          PAGE_NAME.ENROLIMENT_STATUS,
          PAGE_NAME.HIGH_SCHOOL,
          PAGE_NAME.COLLEGE_AND_UNIVERSITY,
        ];
        break;
      case 4:
        requiredPages = [PAGE_NAME.GENERAL_TEST];
        if (roleTest?.satTest) {
          requiredPages.push(PAGE_NAME.SAT_TEST);
        }
        if (roleTest?.actTest) {
          requiredPages.push(PAGE_NAME.ACT_TEST);
        }
        if (roleTest?.actSubjectTest) {
          requiredPages.push(PAGE_NAME.ACT_SUBJECT_TEST);
        }
        if (roleTest?.ibSubjectTest) {
          requiredPages.push(PAGE_NAME.IB_SUBJECT_TEST);
        }
        if (roleTest?.clepTest) {
          requiredPages.push(PAGE_NAME.CLEP_TEST);
        }
        break;
      case 5:
        requiredPages = [
          PAGE_NAME.GENERAL_COURSE,
          PAGE_NAME.GRADE_9,
          PAGE_NAME.GRADE_10,
          PAGE_NAME.GRADE_11,
          PAGE_NAME.GRADE_12,
          PAGE_NAME.COLLEGE_COURSE,
        ];
        break;
      case 6:
        requiredPages = [
          PAGE_NAME.ACTIVITIES,
          PAGE_NAME.HONORS,
          PAGE_NAME.EDUCATIONAL_PROGRAMS,
          PAGE_NAME.RESPONSIBILITIES_AND_CIRCUMSTANCES
        ];
        break;
      case 7:
        requiredPages = [
          PAGE_NAME.ADDITIONAL_INFO,
          PAGE_NAME.ADDITIONAL_INFO_1,
          PAGE_NAME.ADDITIONAL_INFO_2,
          PAGE_NAME.ADDITIONAL_INFO_3,
        ];
        break;
      case 9:
        requiredPages = [PAGE_NAME.GPA_FORECASTER];
        break;
      default:
        return false;
    }

    if (checkCounselorVerified) {
      return requiredPages.every((pageName) =>
        pageStatus.some(
          (item) =>
            item.page_name === pageName && item.student_completed && item.counselor_verified
        )
      );
    } else {
      return requiredPages.every((pageName) =>
        pageStatus.some((item) => item.page_name === pageName && item.student_completed)
      );
    }
  };

  // Check if all groups (1-7, 9) are completed
  const allTrue = [1, 2, 3, 4, 5, 6, 7].every((groupId) => checkGroupCompleted(groupId, false));
  const allCounselorTrue = [1, 2, 3, 4, 5, 6, 7].every((groupId) => checkGroupCompleted(groupId, true));
  const isActive = location.pathname === props.child?.path;
  return (
    <ListItemButton
      key={props.index}
      component="div"
      sx={{ 
        pl: 2, 
        py: 2,
        borderRadius: '8px',
        margin: '2px 0',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: isActive ? 'rgba(77, 136, 240, 0.12)' : 'transparent',
        borderLeft: '3px solid transparent',
        '&:hover': {
          backgroundColor: isActive ? 'rgba(77, 136, 240, 0.18)' : 'rgba(77, 136, 240, 0.06)',
        }
      }}
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        if (props.onClickItem) {
          props.onClickItem(props.child);
        }
      }}
    >
      <span className="text-secondary">{props.child?.icon}</span>
      <span
        className={
          location.pathname === props.child?.path
            ? 'text-primary fw-bold'
            : 'text-dark'
        }
      >
        {props.child?.name}
      </span>
      <span
        className="ms-auto"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
      >
        {allTrue && (
          <img
            alt="csu"
            src="./assets/icons/tick-blue.svg"
            style={{ marginTop: '-8px', marginLeft: '4px' }}
          />
        )}
        {allCounselorTrue && (
          <img
            alt="csu"
            src="./assets/icons/tick-green.svg"
            style={{ marginTop: '-8px', marginLeft: '4px' }}
          />
        )}
      </span>
    </ListItemButton>
  );  
}

export default CounselorListMenu;
